module.exports = __webpack_public_path__ + "img/Logo_Ward_R.246a419d.jpg";